"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("../../../components/Button");
const react_router_dom_1 = require("react-router-dom");
const ContactInfoForm_1 = __importDefault(require("../../DonorContactInformation/components/ContactInfoForm"));
const react_1 = require("react");
const Alert_1 = require("../../../components/Alert");
const useDonorContactInformation_1 = __importDefault(require("../../../hooks/useDonorContactInformation"));
const react_query_1 = require("@tanstack/react-query");
const store_1 = require("../../../store/store");
const WebsiteHeader_1 = __importDefault(require("./WebsiteHeader"));
const classnames_1 = __importDefault(require("classnames"));
const CreateDonor = () => {
    const hasAcceptedTerms = new URL(window.location.href).searchParams.get('hasAcceptedTerms') === 'true';
    const [error, setError] = (0, react_1.useState)(null);
    const [termsApproved, setTermsApproved] = (0, react_1.useState)(hasAcceptedTerms);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const donorContactInformation = (0, useDonorContactInformation_1.default)({ enabled: hasAcceptedTerms });
    const appSettings = (0, store_1.useAppSelector)((state) => state.app.appSettings);
    const { showHeaderOnLoginPage } = appSettings || {};
    const fixedDonorContactInformation = donorContactInformation.map((item) => {
        if (item.key === 'sendAwardMessages') {
            return Object.assign(Object.assign({}, item), { value: false });
        }
        return item;
    });
    const handleAcceptTerms = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!termsApproved) {
            alert(__.trans('create-donor.validate-accept-terms'));
            return;
        }
        try {
            setIsLoading(true);
            const response = yield axios.post('/api/create-donor');
            if (response.data.replyStatus.status === 'OK') {
                yield queryClient.prefetchQuery({
                    queryKey: ['GetDonorContactInformation'],
                    queryFn: () => axios
                        .get('/api/get-donor-contact-information')
                        .then((response) => response.data.data.filter((x) => x)),
                });
                navigate(`?hasAcceptedTerms=true`);
            }
            else {
                setError(response.data.replyStatus.errorMessage);
            }
        }
        catch (error) {
            setError(__.trans('create-donor.error'));
            console.error(error);
        }
        finally {
            setIsLoading(false);
        }
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showHeaderOnLoginPage && (0, jsx_runtime_1.jsx)(WebsiteHeader_1.default, {}), (0, jsx_runtime_1.jsxs)("div", { id: "create-donor", className: (0, classnames_1.default)('container', { 'has-accepted-terms': hasAcceptedTerms }), children: [(0, jsx_runtime_1.jsx)(Alert_1.Alert, { isOpen: !!error, toggle: () => setError(null), color: "danger", children: error }), hasAcceptedTerms ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "title-wrapper", children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-center", children: __.trans('create-donor.finish-title') }), (0, jsx_runtime_1.jsx)("p", { className: "text-center m-0 ingress", children: (0, jsx_runtime_1.jsx)("strong", { children: __.trans('create-donor.finish-subtitle') }) })] }), (0, jsx_runtime_1.jsx)("div", { id: "donor-contact-information", children: (0, jsx_runtime_1.jsx)(ContactInfoForm_1.default, { donorContactInformation: fixedDonorContactInformation, context: "create-donor" }) })] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("h1", { className: "text-center", children: __.trans('create-donor.title') }), (0, jsx_runtime_1.jsxs)("div", { className: "d-flex flex-nowrap gap-2 justify-content-start", children: [(0, jsx_runtime_1.jsx)("input", { id: "confirm", type: "checkbox", className: "checkbox", onChange: (e) => setTermsApproved(e.target.checked), checked: termsApproved }), (0, jsx_runtime_1.jsx)("label", { htmlFor: "confirm", className: "checkbox-label", children: __.trans('create-donor.accept-terms') })] }), (0, jsx_runtime_1.jsx)(Button_1.Button, { className: "theme-button-primary", onClick: handleAcceptTerms, disabled: isLoading, children: __.trans('create-donor.continue') })] })), (0, jsx_runtime_1.jsx)("div", { id: "cancel-and-logout", children: (0, jsx_runtime_1.jsx)("button", { className: "cancel-button", onClick: () => {
                                sessionStorage.setItem('login', 'false');
                                navigate('/auth/logout');
                            }, "aria-label": __.trans('create-donor.aria-label-cancel'), children: __.trans('create-donor.cancel') }) })] })] }));
};
exports.default = CreateDonor;
